import React from 'react';
import { Row, Col, Button } from 'reactstrap';

const ReactPdfPagination = (props) => {

  const {
    data: {
      currentPage,
      totalPages
    },
    callbacks: {
      onChangePage: onChangePageCallback
    }
  } = props;

  return (
    <Row>
      <Col col={12}>
        <Button
          color='secondary'
          onClick={() => onChangePageCallback(1)}
          disabled={currentPage <= 1}
          className='btn-sm'
        >
          {`<<`}
        </Button>

        <Button
          color='secondary'
          onClick={() => onChangePageCallback(currentPage - 1)}
          disabled={currentPage <= 1}
          className='btn-sm'
        >
          {`<`}
        </Button>

        <span className="mx-2">
          {`Página ${currentPage} de ${totalPages}`}
        </span>

        <Button
          color='secondary'
          onClick={() => onChangePageCallback(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className='btn-sm'
        >
          {`>`}
        </Button>
        <Button
          color='secondary'
          onClick={() => onChangePageCallback(totalPages)}
          disabled={currentPage >= totalPages}
          className='btn-sm'
        >
          {`>>`}
        </Button>
      </Col>
    </Row >
  );
};

export default ReactPdfPagination;
